import { useCallback, useEffect, useRef } from 'react';
import { getSnapshotPromise } from 'retil-source';
import { Deferred } from 'retil-support';
import { waitForResponse } from '../routerUtils';
// Avoid the `use` name to disable the no conditional hooks lint check.
import { useRouterSourceBlocking as _useRouterSourceBlocking } from './useRouterSourceBlocking';
import { useRouterSourceConcurrent as _useRouterSourceConcurrent } from './useRouterSourceConcurrent';
export var useRouterSource = function (source, options) {
    if (options === void 0) { options = {}; }
    var _a = options.unstable_isConcurrent
        ? _useRouterSourceConcurrent(source, options)
        : _useRouterSourceBlocking(source, options), snapshot = _a[0], pending = _a[1];
    var request = snapshot.request;
    var latestSourceRef = useRef(source);
    var latestRequestRef = useRef(request);
    var waitingDeferredsRef = useRef([]);
    // Only change the source once it's commited, as we don't want to wait for
    // changes from sources that never subscribed to.
    useEffect(function () {
        latestRequestRef.current = request;
        latestSourceRef.current = source;
        var deferreds = waitingDeferredsRef.current.slice();
        waitingDeferredsRef.current = [];
        for (var _i = 0, deferreds_1 = deferreds; _i < deferreds_1.length; _i++) {
            var deferred = deferreds_1[_i];
            deferred.resolve();
        }
    }, [request, source]);
    var waitUntilNavigationCompletes = useCallback(function () {
        var source = latestSourceRef.current;
        return getSnapshotPromise(source).then(function (snapshot) {
            return waitForResponse(snapshot.response).then(function () {
                if (source !== latestSourceRef.current) {
                    // The source has updated, so start waiting with the new source
                    return waitUntilNavigationCompletes();
                }
                else if (snapshot.request !== latestRequestRef.current) {
                    // The latest snapshot hasn't been rendered yet, so wait until
                    // the effect where it is first rendered.
                    var deferred = new Deferred();
                    waitingDeferredsRef.current.push(deferred);
                    return deferred.promise.then(waitUntilNavigationCompletes);
                }
                else {
                    return snapshot;
                }
            });
        });
    }, []);
    return [snapshot, pending, waitUntilNavigationCompletes];
};
export * from './useRouterSourceCommon';
